
import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { Table, Autocomplete, CircularProgress, TableBody, Grid, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useMemo, useCallback } from 'react';
import { debounce } from 'lodash'; 
import { useAccesos } from '../contexts/AccesosContext';

function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index} style={{ marginTop: '20px' }}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}



function AddTarea ({ handleNewTarea, editTarea, idOportunidad, cancelarEdicion}){
     // Estado para el título, descripción y selección del ComboBox
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [tituloTarea, setTituloTarea] = useState('');
    const [descripcionTarea, setDescripcionTarea] = useState('');
    const [estadosTarea, setEstadosTarea] = useState('');
    const [prioridadTarea, setPrioridadTarea] = useState('');
    const [tareaPadre, setTareaPadre] = useState('');
    const [estadoSeleccionado, setEstadoSeleccionado] = useState(null);
    const [prioridadSeleccionada, setPrioridadSeleccionada] = useState(null);
    const [fechaVencimiento, setFechaVencimiento] = useState('');
    const [tareaPadreSeleccionada, setTareaPadreSeleccionada] = useState(null);
    const [oportunidad, setOportunidad] = useState([])
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');
    const [usuarios, setUsuarios] = useState([]);
    // const [userAsignado, setUserAsignado] = useState('');
    const [userAsignadoSeleccionado, setUserAsignadoSeleccionado] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [inputValue, setInputValue] = useState('');
    const [totalUsuarios, setTotalUsuarios] = useState(0);

    const { user } = useUser();
    const { tienePermiso } = useAccesos();
        // Obtener la fecha y hora actual
        function obtenerFechaISOsinZ() {
            const fecha = new Date();
            let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
            fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
            return fechaISO;
    }

    const fetchEstadosTarea = async () => {
            try {
                const response = await fetch(`${server}/CrmEstadoTareas`);
                const data = await response.json();
                setEstadosTarea(data.$values);
            } catch (error) {
                console.error('Error al cargar los estados de tarea:', error);
                Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar los Estados de Tarea: ' + error,
            });
            }
    };
    
    const fetchPrioridadTarea = async () => {
            try {
                const response = await fetch(`${server}/CrmPrioridadTareas`);
                const data = await response.json();
                setPrioridadTarea(data.$values);
            } catch (error) {
                console.error('Error al cargar las prioridades de tarea:', error);
                Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar las prioridades de tarea: ' + error,
            });
            }
        }; 


    const fetchTareas = async () => {
            try {
                const response = await fetch(`${server}/CrmTareas`);
                const data = await response.json();
                setTareaPadre(data.$values);
            } catch (error) {
                console.error('Error al cargar las tareas:', error);
                Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar las Tareas: ' + error,
            });
            }
        }; 


    const fetchUsuarios = async (search = '') => {
        // const page = 1;
        // const limit = 100;
        setIsLoading(true);
        try {
          
        const response = await fetch(`${server}/MgUsuarios/buscador/${encodeURIComponent(search)}`);

            const data = await response.json();
            console.log('Respuesta API: ',data);


            //  const listaCruda = data.usuarios?.$values || [];
            // const listaResuelta = resolverReferencias(listaCruda);

            const usuariosArray = data.usuarios?.$values || [];

            if (Array.isArray(usuariosArray)) {
            setUsuarios(usuariosArray);
            console.log('✅ Usuarios seteados:', data.usuarios);
            } else {
            console.warn('⚠️ La API no devolvió un array de usuarios');
            setUsuarios([]);
            }
            
        } catch (error) {
            console.error('Error al cargar los usuarios:', error);
            Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al cargar los usuarios: ' + error,
            });
            setUsuarios([]);
            // setHasMore(false);
            
        } finally {
            setIsLoading(false);
        }
    }; 



        const fetchUsuarioPorCodigo = async (codigoUsuario) => {
                try {
                    const response = await fetch(`${server}/MgUsuarios/porCodigo/${encodeURIComponent(codigoUsuario)}`)
                    if (response.ok) {
                        const data = await response.json();
                        setUserAsignadoSeleccionado(data);
                    }else {
                        console.log('Usuario no encontrado');
                    }
                } catch (error){
                    console.error('Error al cargar el usuario por codigo', error);
                }
            };


useEffect(() => {
  if (inputValue.length >= 2) {
    fetchUsuarios(inputValue);
  } else {
    setUsuarios([]);
  }
}, [inputValue]);


useEffect(() => {
        fetchEstadosTarea();
        fetchPrioridadTarea();
        fetchUsuarios();
        fetchTareas();
    }, []);
    // Convertir a una cadena en formato ISO 8601
    const fechaFormateada = obtenerFechaISOsinZ();

      useEffect(() => {
        if (editTarea && estadosTarea.length && prioridadTarea.length && tareaPadre.length) {
          setTituloTarea(editTarea.tituloTarea);
          setDescripcionTarea(editTarea.descripcionTarea); // Cargar la descripción de la raza para editar

        const estadoMatch = estadosTarea.find(e => e.id === editTarea.idEstadoTarea);
        const prioridadMatch = prioridadTarea.find(f => f.id === editTarea.idPrioridadTarea);
        const tareaPadreMatch = tareaPadre.find(g => g.id === editTarea.idTareaPadre);
        const userAsignadoMatch = usuarios.find(h => h.codigoUsuario === editTarea.userAsignado);
        
        if (userAsignadoMatch) {
            setUserAsignadoSeleccionado(userAsignadoMatch);
        }else if (editTarea.userAsignado){
            fetchUsuarioPorCodigo(editTarea.userAsignado);
        }else {
            setUserAsignadoSeleccionado(null);
        }
        setEstadoSeleccionado(estadoMatch || null);
        setPrioridadSeleccionada(prioridadMatch || null);
        setTareaPadreSeleccionada(tareaPadreMatch || null);
        setFechaVencimiento(editTarea.fechaVencimiento);
        setModificacion(2);
        setIngresadoPor(editTarea.ingresadoPor);
          
      
        } else {
          setTituloTarea('');
          setDescripcionTarea(''); // Resetear la descripción si no estamos editando
          setEstadoSeleccionado(null);
          setPrioridadSeleccionada(null);
          setTareaPadreSeleccionada(null);
        //   setUserAsignadoSeleccionado(null);
          setFechaVencimiento('');
          setModificacion(1);
          setIngresadoPor('');
      
        }
    }, [editTarea]);




    const handleSubmit = async (e) => {
            e.preventDefault();
            const method = editTarea? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear
            const endpoint = editTarea ? `${server}/CrmTareas/${editTarea.id}` : `${server}/CrmTareas`;
    
            const tarea = { 
                id:editTarea ? editTarea.id:0,
                tituloTarea,
                descripcionTarea,
                idEstadoTarea: estadoSeleccionado?.id || null,
                idPrioridadTarea: prioridadSeleccionada?.id || null,
                idTareaPadre: tareaPadreSeleccionada?.id || null,
                idOportunidad, //almacena el id de campania correspondiente
                fechaVencimiento,
                IngresadoPor: !editTarea ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                ModificadoPor: editTarea ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
                modificacion,
                fechaIngreso: fechaFormateada,
                userAsignado: userAsignadoSeleccionado?.codigoUsuario || null,
            };


        

            Object.keys(tarea).forEach(key => tarea[key] === undefined && delete tarea[key]);

            
            // console.log(endpoint)
            try {
                const response = await fetch(endpoint, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(tarea),
                });
    
                if (response.ok) {
                    // Limpiar el formulario y manejar la respuesta si es necesario
                    setTituloTarea('');
                    setDescripcionTarea('');
                    setEstadoSeleccionado(null);
                    setPrioridadSeleccionada(null);
                    setTareaPadreSeleccionada(null);
                    setUserAsignadoSeleccionado(null);
                    setFechaVencimiento('');
                    setModificacion(1);
                    setIngresadoPor('');
                    Swal.fire({
                        icon: 'success',
                        title: 'Operación exitosa',
                        showConfirmButton: false,
                        timer: 1500
                    });         
                    handleNewTarea();
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });            }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar la Campaña',
                    text: error || 'Ocurrió un error inesperado',
                });        }
        };

        const handleCancelarEdicion = () => {
            setTituloTarea('');
            setDescripcionTarea('');
            setEstadoSeleccionado(null);
            setPrioridadSeleccionada(null);
            setTareaPadreSeleccionada(null);
            setUserAsignadoSeleccionado(null);
            setFechaVencimiento('');
            setModificacion(1);
            setIngresadoPor('');
            if(cancelarEdicion) cancelarEdicion();
        }
    

    return (
        <>
        <h2>{editTarea ? 'Editar Tarea' : 'Agregar Nueva Tarea'}</h2>
        <br />
        <form onSubmit={handleSubmit} className="form-horizontal form-label-left" >
            <div className="item form-group">
            <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="tituloTarea">
                    Titulo: <span className="required">*</span>
                </label>
                <div className="col-md-4 col-sm-3">
                    <input
                        type="text"
                        id="tituloTarea"
                        required="required"
                        className="form-control"
                        value={tituloTarea}
                        onChange={(e) => setTituloTarea(e.target.value)}
                    />
                </div>
                <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="descripcionTarea">
                    Descripción: <span className="required">*</span>
                </label>
                <div className="col-md-4 col-sm-3">
                    <input
                        type="text"
                        id="descripcionTarea"
                        required="required"
                        className="form-control"
                        value={descripcionTarea}
                        onChange={(e) => setDescripcionTarea(e.target.value)}
                    />
                </div>
            </div>

              {/* ComboBox con Búsqueda (Autocomplete) */}
                <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="estadoTareaSeleccionada">
                        Estado: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                            options={estadosTarea}
                            getOptionLabel={(option) => option.estado}
                            value={estadoSeleccionado}
                            onChange={(event, newValue) => setEstadoSeleccionado(newValue)}
                            renderInput={(params) => <TextField {...params} label="Opciones" />}
                            isOptionEqualToValue={(option, value) => option.label === value.label}
                            disableClearable
                        />
                    </div>
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="prioridadTareaSeleccionada">
                        Prioridad: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                            options={prioridadTarea}
                            getOptionLabel={(option) => option.prioridad}
                            value={prioridadSeleccionada}
                            onChange={(event, newValue) => setPrioridadSeleccionada(newValue)}
                            renderInput={(params) => <TextField {...params} label="Opciones" />}
                            isOptionEqualToValue={(option, value) => option.label === value.label}
                            disableClearable
                        />
                    </div>
                </div>
                <div className="item form-group">
                    {/* <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="tareaPadreSeleccionada">
                        Tarea Padre: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                            options={tareaPadre}
                            getOptionLabel={(option) => option.tituloTarea}
                            value={tareaPadreSeleccionada}
                            onChange={(event, newValue) => setTareaPadreSeleccionada(newValue)}
                            renderInput={(params) => <TextField {...params} label="Opciones" />}
                            isOptionEqualToValue={(option, value) => option.label === value.label}
                            disableClearable
                        />
                    </div> */}
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="descripcionTarea">
                        Fecha Vencimiento: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <input
                            type="date"
                            id="fechaVencimiento"
                            required="required"
                            className="form-control"
                            value={fechaVencimiento}
                            onChange={(e) => setFechaVencimiento(e.target.value)}
                        />
                    </div>
                </div>
                 <div className="item form-group">
                 <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="prioridadTareaSeleccionada">
                        Tarea asignada a: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                                size="small"
                                fullWidth
                                inputValue={inputValue}
                                options={usuarios}
                                value={userAsignadoSeleccionado}
                                getOptionLabel={(option) =>  
                                    typeof option === 'string'
                                    ? option
                                    : option?.nombreCompleto || '[Sin nombre]'
                                }
                                isOptionEqualToValue={(option, value) => option?.codigoUsuario=== value?.userAsignado}
                                onInputChange={(event, newInputValue) => { setInputValue(newInputValue)}}
                                onChange={(event, newValue) => { setUserAsignadoSeleccionado(newValue)}}
                                loading={isLoading}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        label="Buscar usuario"
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                        />
                    </div>
                </div>

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Tarea CRM')}>
                        {editTarea ? 'Actualizar' : 'Guardar'}
                    </button>
                    {editTarea && (
                        <button type="button" className="btn btn-secondary" onClick={handleCancelarEdicion}>
                            Cancelar
                        </button>
                    )}
                </div>
            </div>
        </form>
    </>
    )
}


export default AddTarea;